<template>
  <div>
    <div class="within_box">
      <div class="title_box">
        <p class="line"></p>
        <p class="title">反馈信息</p>
      </div>
      <el-form :model="feedbackForm" ref="feedbackForm" :rules="rules" label-width="100px">
        <el-row>
          <el-col>
            <el-form-item label="反馈结果" prop="feedbackResults">
              <el-input v-model="feedbackForm.feedbackResults" disabled style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="建议责任方" prop="proposeResponsibleParty">
              <ic-select clearable table="TT_QSPI_QIP" field="RESPONSIBLE_PARTY" placeholder="请选择" v-model="feedbackForm.proposeResponsibleParty" style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="理由" prop="reason">
              <el-input v-model="feedbackForm.reason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="within_box">
      <div class="title_box">
        <p class="line"></p>
        <p class="title">附件</p>
      </div>
      <el-row style="margin-bottom:5px">
        <el-upload ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
          <el-button slot="trigger" size="small" type="primary">上传</el-button>
        </el-upload>
      </el-row>
      <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
        <el-table-column align="center" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="onDel(scope.row.tmDocumentId,scope.$index,tableData,scope.row)" v-if="ms_userId===scope.row.createBy">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="文件名称" prop="documentName" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="onDownload(scope.row,scope.$index)">{{scope.row.documentName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="上传人" prop="userName" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" label="上传时间" prop="createDate" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <el-row type="flex" justify="center" style="margin-top:10px">
      <el-button size="small" type="primary" @click="onSubmit">提交</el-button>
      <el-button size="small" type="primary" @click="onCancel">取消</el-button>
    </el-row>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import QBRApi from "@/api/QBR/index";
import QIPApi from "@/api/QIP/index";
export default {
  props: ['id', 'form', 'idList', 'proposeResponsibleParty', 'userId'],
  components: {
    IcSelect,
  },
  data() {
    return {
      feedbackForm: {
        feedbackResults: "有异议",
        proposeResponsibleParty: "",
        reason: "",
        type: "OBJECTION",
      },
      rules: {
        proposeResponsibleParty: [
          { required: true, message: '请选择建议责任方', trigger: 'change' },
        ],
        reason: [
          { required: true, message: '请输入理由', trigger: 'blur' },
        ],
      },
      tableData: [],
      ttQspiQipId: '',
      ms_userId: null
    }
  },
  watch: {
    id: {
      handler(newV, oldV) {
        if (newV) {
          this.ttQspiQipId = newV
          this.getFileLists(newV)
        }
      },
      immediate: true
    },
    form: {
      handler(newV, oldV) {
        if (newV) {
          this.feedbackForm = JSON.parse(newV)
          this.feedbackForm.feedbackResults = '有异议'
          this.feedbackForm.type = 'OBJECTION'
        }
      },
      immediate: true
    },
    idList: {
      handler(newV, oldV) {
        console.log('idList', newV);
        if (newV) {
          this.feedbackForm.idList = newV
        }
      },
      immediate: true,
      deep: true
    },
    proposeResponsibleParty: {
      handler(newV, oldV) {
        console.log('proposeResponsibleParty', newV);
        if (newV) {
          this.feedbackForm.proposeResponsibleParty = newV
        }
      },
      immediate: true
    },
    userId: {
      handler(newV, oldV) {
        if (newV) {
          console.log('newV1111111111', newV);
          this.ms_userId = newV
        }
      },
      immediate: true
    }
  },
  methods: {
    onSubmit() {
      this.$refs['feedbackForm'].validate((valid) => {
        if (valid) {

          var arr = this.tableData.filter(ele => {
            return ele.createBy === this.ms_userId
          })
          if (arr.length == 0) {
            this.$message.error("请上传附件")
            return false
          }
          console.log('this.feedbackForm', this.feedbackForm);
          if (this.idList && this.idList.length > 0) {
            QIPApi.updateBatchQipStatus(this.feedbackForm).then(res => {
              console.log('updateBatchQip', res);
              if (res.meta.code === 200) {
                this.$message.success('提交成功')
                this.$emit('onCloseObject')
              }
            })
          } else {
            QIPApi.updateQip(this.feedbackForm).then(res => {
              console.log('res213131', res);
              if (res.code === '200') {
                this.$message.success('提交成功')
                this.$emit('onCloseObject')
              }
            })
          }
        }
      })
    },
    uploadConfirm(item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      //调用成功后调用后台方法进行文件关系维护
      fileService.fileUpload(formData).then(res => {
        let attachment = {};
        attachment.seq = "1";
        attachment.documents = res.data[0];
        attachment.tsRecId = this.ttQspiQipId;
        if (this.idList) {
          attachment.recIds = this.idList;
        }
        attachment.tsReckindId = "QSPI_QIP_FILE";
        fileService.saveFile(attachment).then(saveRes => {
          if (this.idList) {
            _this.getFileLists(this.idList[0]);
          } else {
            _this.getFileLists(this.ttQspiQipId);
          }
        });
      }).catch(error => {
        //文件上传失败
        _this.$message({
          type: "error",
          message: _this.$t("common.fileUploadFailed")
        });
      });
    },
    getFileLists(ttQspiQipId) {
      QBRApi.getFileLists({
        seq: '1',
        tsReckindId: "QSPI_QIP_FILE",
        tsRecId: ttQspiQipId,
      }).then(res => {
        console.log('res', res);
        this.tableData = res
      });
    },
    onDel(tmDocumentId, index, files, row) {
      var ms_userId = localStorage.getItem('ms_userId')
      if (tmDocumentId) {
        if (ms_userId == row.createBy) {
          fileService.deleteFile(tmDocumentId).then((res) => {
            if (res.code === '200') {
              files.splice(index, 1);
            }
          })
        } else {
          this.$message.error('')
        }
      } else {
        //还没保存
        files.splice(index, 1);
      }
    },
    onCancel() {
      this.$emit('onCloseObject')
    },
    onDownload(row, index) {
      fileService.downloadFile(row).then((res) => { })
    },
  }
}
</script>

<style>
</style>
